import { FireAuthService } from '../../firebase/firebase-services/fireAuth.service';
import { Component, OnInit } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';
@Component({
  selector: 'navbar-admin',
  templateUrl: './navbar-admin.component.html',
  styleUrls: ['./navbar-admin.component.scss']
})
export class NavbarAdminComponent implements OnInit {

  constructor(
    private authService: FireAuthService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  goTo(route: string){
    this.router.navigate([route]);
  }

  logout(){
    this.authService.logout();
    this.router.navigate(['/login']);
  }

}
